var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./rtDropdownItem.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-73310434\"}!../../../../vue-loader/lib/selector?type=template&index=0!./rtDropdownItem.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/components/dropdown/rtDropdownItem.vue
// module id = 1898
// module chunks = 228